import React from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';

import { messages } from './pull-request-activity-events.i18n';
import * as styles from './pull-request-event.styled';

const PullRequestChangesRequestedEvent = () => (
  <>
    <Lozenge appearance="moved">
      <FormattedMessage {...messages.changesRequestedEventLozenge} />
    </Lozenge>
    <styles.MessageText>
      <FormattedMessage {...messages.changesRequested} />
    </styles.MessageText>
  </>
);

export default PullRequestChangesRequestedEvent;
